import React, { useState, useEffect } from "react";
import Typography from "@material-ui/core/Typography";
import UserCard from "./UserCard";
import { makeStyles } from "@material-ui/core/styles";
import { Container, CircularProgress } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  imageContainer: {
    position: "relative",
    textAlign: "center",
    alignContent: "center",
  },
  media: {
    width: "100%",
    height: "600px",
    objectFit: "cover",
    [theme.breakpoints.down("sm")]: {
      height: 450,
    },
  },
  centeredContent: {
    fontSize: "34",
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    background: "rgba(252, 252, 252, 0.8)",
    width: "100%",
    padding: "200px 0",
  },
  userAlign: {
    marginTop: "6.125rem",
    display: "flex",
    justifyContent: "center",
    [theme.breakpoints.down("sm")]: {
      marginTop: "4.125rem",
    },
    loading: {
      textAlign: "center",
      marginTop: "5em",
    },
  },
}));

const BlogDetailCard = ({ title, image, authorId }) => {
  const classes = useStyles();
  const [author, setAuthor] = useState({});
  const [isLoaded, setisLoaded] = useState(false);

  useEffect(() => {
    const getAuthorUrl = `https://natakallam.com/wp-json/wp/v2/users/${authorId}`;

    fetch(getAuthorUrl)
      .then((res) => res.json())
      .then((author) => {
        setAuthor(author);
        setisLoaded(true);
      });
  }, [authorId]);
  if (isLoaded) {
    return (
      <div className={classes.imageContainer}>
        <img alt={title} className={classes.media} src={image} />

        <div className={classes.centeredContent}>
          <Typography variant="h1" color="primary">
            {title}
          </Typography>

          <div className={classes.userAlign}>
            <UserCard
              avatar={author.name.charAt(0)}
              person={author.name}
              job={author.description}
            />
          </div>
        </div>
      </div>
    );
  }
  return (
    <Container className={classes.imageContainer}>
      <CircularProgress color="secondary" />
    </Container>
  );
};

export default BlogDetailCard;
